import React from 'react';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

export default function NavBarNotificationBar() {
    let navigate = useNavigate();

    const logoff = ()=>{
        Swal.fire({
            title: 'Aviso!',
            text: "Deseja sair do sistema?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, Sair agora.'
          }).then((result) => {
            if (result.value) {
                navigate('/sair');
            }
          })       
    }

    return (
        <>
            <ul className="navbar-nav ml-auto">
                <li className="nav-item dropdown">
                    <a className="nav-link" data-toggle="dropdown" onClick={()=> logoff()} >                        
                        <span className="fa fa-sign-out"></span>
                    </a>
                </li>    
            </ul>
        </>
    )
}
